import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import mqtt from "mqtt";

function parseTimestamp(timestamp) {
  try {
    const [datePart, timePart] = timestamp.split(" ");
    const [day, month, year] = datePart.split("/").map(Number);
    const [hour, minute, second] = timePart.split(":").map(Number);

    return new Date(year, month - 1, day, hour, minute, second);
  } catch (e) {
    // console.log(e);
    return new Date();
  }
}
const OnlineIcon = ({ timestamp }) => {
  const [isOnline, setIsOnline] = useState(false);

  useEffect(() => {
    const updateColor = () => {
      const currentTime =
        new Date().getTime() + new Date().getTimezoneOffset() * 60000;
      const date = parseTimestamp(timestamp);
      const lastHeartbeat = date.getTime();
      const timeDifference = (currentTime - lastHeartbeat) / 1000; // Convert to seconds
      const isOnline = timestamp?timeDifference <= 10:false; // 10 seconds
      setIsOnline(isOnline);
    };

    updateColor();
    const interval = setInterval(updateColor, 1000);
    return () => clearInterval(interval);
  }, [timestamp]);

  return (
    <>
      <div
        style={{
          width: "12px",
          height: "12px",
          borderRadius: "50%",
          backgroundColor: isOnline ? "#28a745" : "#dc3545",
          boxShadow: isOnline ? "0px 0px 8px #28a745" : "none",
          animation: isOnline ? "pulse 1s infinite" : "none",
          marginBlock: "5px",
        }}
      ></div>
      <style>
        {`
      .spinner {
        border: 4px solid rgba(0, 0, 0, 0.1);
        border-left-color: #8ec0fc;
        width: 80px;
        height: 80px;
        border-radius: 50%;
        animation: spin 1s linear infinite;
        display:flex
      }
      @keyframes spin {
        to { transform: rotate(360deg); }
      }
      @keyframes pulse {
        0% {
          box-shadow: 0 0 5px #28a745;
        }
        50% {
          box-shadow: 0 0 15px #28a745;
        }
        100% {
          box-shadow: 0 0 5px #28a745;
        }
      }
    `}
      </style>
    </>
  );
};
function DeviceInfo() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading2, setloading2] = useState(true);
  const [showIcon, setShowIcon] = useState(false);

  const [dataArr, setDataArr] = useState([]);
  useEffect(() => {
    if (!location.state) {
      console.log("abc@@@");
      if (localStorage.getItem("loggedin")) {
        navigate("/management");
        return;
      } else {
        navigate("/");
        return;
      }
    } else {
      console.log("abc");
    }
    const client = mqtt.connect("wss://mqtt.db2sg.com:9001/mqtt");

    client.on("connect", () => {
      console.log("MQTT Connected (DeviceInfo)");
      client.subscribe("#");
    });
    
    client.on("message", (topic, message) => {
      try {
        if (!topic.includes("heartbeat")) return;
    
          const deviceId = topic.split("/")[0];
    
        // Update ONLY the device that matches ESP ID
        setDataArr(prev =>
          prev.map(d =>
            d.esp_id === deviceId ? { ...d, heartbeat: message?.toString() } : d
          )
        );
        setShowIcon(true)
      } catch (e) {
        console.log("MQTT JSON error", e);
      }
    });
    
    return () => {
      client.removeAllListeners("message");
      dataArr.forEach((d) => {
        client.unsubscribe(`${d.esp_id}/heartbeat`);
      });
  client.end();
    };
    
    // eslint-disable-next-line
  }, []);
  const fetchdevice = async() =>{
    fetch(`https://api.db2sg.com/esps`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `HTTP error! Status: ${response?.status} ${response?.statusText}`
          );
        }
        return response.json();
      })
      .then((result) => {
        if (result) {
          let x = { ...(location.state.devices) };
          console.log(x, result, "####");
          let arr = Object.keys(x).map((e) => {
            const deviceFromResult = result.data.find((d) => d.id === e);
            return {
              esp_id: e,
              heartbeat: deviceFromResult?.heartbeat || null,
              ...x[e],
            };
          });

          console.log(arr);
          setDataArr(arr);
          setloading2(false);
        }
      })
      .catch((error) => console.log(error));
  }

  useEffect(() => {
fetchdevice()

         // eslint-disable-next-line
  }, []);

  return (
    <div
      style={{
        padding: "40px",
        minHeight: "85vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
      }}
    >
      {/* <h2 style={{ color: "#FF6B00", marginBottom: "20px" }}>Device Info</h2> */}
      {loading2 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "70vh",
          }}
        >
          <div className="spinner"></div>
        </div>
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: "20px",
            width: "100%",
            maxWidth: "1300px",
          }}
        >
          {dataArr.map((el, index) => (
            <div
              key={index}
              style={{
                background: "white",
                borderLeft: `8px solid ${
                  el.provisioned ? "#8ec0fc" : "#8ec0fc"
                }`,
                padding: "30px",
                borderRadius: "12px",
                boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.1)",
                textAlign: "left",
                cursor: "pointer",
                transition:
                  "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
                display: "flex",
                alignItems: "center",
                gap: "15px",
                width: "310px",
                height: "170px",
              }}
              onClick={() => {
                if (el.provisioned) {
                  navigate("/devicesdata", {
                    state: { ...el, user: location.state },
                  });
                } else {
                  alert(
                    "Device not provisioned: First provision it from the app"
                  );
                }
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.05)";
                e.currentTarget.style.boxShadow = `0px 5px 15px ${
                  el.provisioned ? "#8ec0fc" : "#dc354555"
                }`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow =
                  "0px 5px 15px rgba(0, 0, 0, 0.1)";
              }}
            >
            {showIcon? <OnlineIcon timestamp={el.heartbeat}></OnlineIcon>:null}
              {/* Device Info */}
              <div>
                <h5 style={{ margin: "0", color: "#000", fontSize: "100%" }}>
                  {el?.deviceName ? el.deviceName : ""}
                </h5>
                <p
                  style={{
                    margin: "5px 0 0",
                    color: "#8ec0fc",
                    fontSize: "100%",
                  }}
                >
                  {el?.name ? el.name : el.esp_id}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
      {/* CSS Animation for Flickering Green Dot */}
      <style>
        {`
          @keyframes pulse {
            0% { opacity: 1; }
            50% { opacity: 0.3; }
            100% { opacity: 1; }
          }
        `}
      </style>
      <style>
        {`
          .spinner {
            border: 4px solid rgba(0, 0, 0, 0.1);
            border-left-color: #8ec0fc;
            width: 80px;
            height: 80px;
            border-radius: 50%;
            animation: spin 1s linear infinite;
            display:flex
          }
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
}

export default DeviceInfo;
